import { updateIntl } from "react-intl-redux";
import {
  getTranslations,
  resolveBestLanguage
} from "@onelogin/react-components";

export const loadTranslations = userLanguage => (dispatch, getState) => {
  const { languageTag, primaryLanguageTag } = resolveBestLanguage({
    userLanguage
  });
  const messages = {
    ...getTranslations(languageTag),
    ...require(`../translations/languages/${languageTag}.json`)
  };

  if (messages) {
    dispatch(updateIntl({ locale: primaryLanguageTag, messages }));
  }
};
